import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Popconfirm, Dropdown, Checkbox, Select, Tag, Switch, Tooltip, notification, Modal, Radio, Space, Popover, Drawer,
  Divider,
} from 'antd';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import {
  FilterOutlined, ControlOutlined, UpCircleTwoTone, ExclamationCircleFilled, FileProtectOutlined, LoadingOutlined, CopyOutlined,
} from '@ant-design/icons';
import Busy from '@Images/admin/integrations/busy.png';
import BulkInvoiceActions from '@Components/Sales/Invoice/InvoiceList/BulkActions';
import H3Text from '@Uilib/h3Text';
import InvoiceActions from '@Actions/invoiceActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate } from '@Apis/constants';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import H3DateSelector from '@Uilib/h3DateSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import TagSelector from '@Components/Common/Selector/TagSelector';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TdsTcsForm from '@Components/Admin/AdminConfiguration/Gst/TdsTcs/TdsTcsForm';
// import BulkReturns from '@Components/Sales/Invoice/InvoiceList/BulkReturns';
import BulkReturns from '@Components/Sales/Invoice/InvoiceList/BulkReturns';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import SelectStatus from '../../../Common/SelectCustomStatus';
import BusyIntegrationActions from '../../../../actions/integrations/busyIntegrationAction';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import PRZSelect from '../../../Common/UI/PRZSelect';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import './style.scss';

const { Option } = Select;
/**
 *
 */
function InvoiceList({
  invoices, getInvoiceLoading, user, getInvoice, history, syncSOLoading, syncSO, getDocCFV2Loading, getDocCFV2, getDocCFV2Success, customFieldsProps, getCustomStatus, getOrgUsers, orgUsers,
  departments, syncInvoice, syncInvoiceLoading, syncTallyInvoiceLoading, syncTallyInvoice, MONEY, updateInvoiceStatus, customStatusInvoice,
  updateInvoiceStatusLoading, downloadInvoiceListLoading, downloadInvoiceList, pushInvoiceToBusy, pushInvoiceToBusyLoading, priceMasking,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [shopifyKeyword, setShopifyKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [shopifySearchKeyword, setShopifySearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['INVOICE_NO']);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [call, setCall] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [source, setSource] = useState([]);
  const [stockStatus, setStockStatus] = useState([]);
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [marketplaceInvoice, setMarketplaceInvoice] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [reportType, setReportType] = useState('document_level');
  const [showBulkReturnsDrawer, setShowBulkReturnsDrawer] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-inv') ? JSON.parse(localStorage.getItem('prcz-page-columns-inv')) : {
    INVOICE_NO: {
      label: 'Invoice#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    SOURCE: {
      label: 'Source',
      visible: false,
    },
    SO_NUMBER: {
      label: `${documentUINames.salesOrderUIName} #`,
      visible: true,
    },
    PS_NUMBER: {
      label: 'Packing Slip #',
      visible: true,
    },
    PO_NUMBER: {
      label: 'Work Order #',
      visible: true,
    },
    SHOPIFY_CODE: {
      label: 'Shopify #',
      visible: false,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    GATE_DOCUMENT: {
      label: 'Gate Document',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    AMOUNT_WITHOUT_TAX: {
      label: 'Amount (Without Tax)',
      visible: false,
    },
    TAXES: {
      label: 'Taxes',
      visible: false,
    },
    AMOUNT_WITH_TAX: {
      label: 'Total Amount',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    INVOICE_DATE: {
      label: 'Invoice Date',
      visible: false,
    },
    DUE_DATE: {
      label: 'Due Date',
      visible: false,
    },
    PAYMENT_STATUS: {
      label: 'Payment Status',
      visible: true,
    },
    FULFILLMENT_STATUS: {
      label: 'Fulfillment Status',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
    SALES_MANAGER: {
      label: 'Sales Manager',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const paymentStatues = [
    { value: 'PAID', label: 'Paid' },
    { value: 'NOT_PAID', label: 'Not Paid' },
    { value: 'PARTIALLY_PAID', label: 'Partially Paid' },
    { value: 'PAID_MORE', label: 'Paid More' },
  ];

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getInvoiceColumns = () => {
    const tableColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/sales/invoice/view/${record?.invoice_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.invoice_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record?.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         {record?.customer_info && (
      //           <div className="mobile-list__item-info">
      //             {`Customer - ${record?.customer_info?.customer_name}`}
      //           </div>
      //         )}
      //         {record?.order_id && <H3Text text={`Order Number - ${record?.sales_order_number}`} className="mobile-list__item-info" />}
      //         <H3Text text={`Invoice Total - ${MONEY(((record?.invoice_grand_total || '0'), record?.org_currency_info?.currency_code), record?.org_currency_info?.currency_code)}`} className="mobile-list__item-info" />
      //         <H3Text text={`Created by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.invoice_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: record?.custom_status_info?.color_code,
                  }}
                  text={record?.custom_status_info?.status_name?.replaceAll('_', ' ').toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.customer_info?.customer_name ? (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Tooltip
                      title={
                        Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                          Helpers.permissionTypes.READ, user)
                          ? (
                            <Link
                            // to={`/sales/customer/view/${record?.customer_id}`} target="_blank"
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                              />
                            </Link>
                          ) : (
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                            />
                          )
                      }
                      color="white"
                    >
                      <PRZText text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`} className="mobile-list__card_item-name" />
                    </Tooltip>
                  </div>
                ) : '-'}

                <PRZText text={`Invoice Date: ${dayjs(record?.invoice_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                <PRZText text={`Due Date: ${record?.invoice_due_date ? dayjs(record?.invoice_due_date).format('DD/MM/YYYY') : '-'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText text={`Sales Manager: ${record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${dayjs(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${dayjs(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Source" />
                  )}
                >
                  <PRZText
                    text={record?.source?.replace(/_/g, ' ')?.toProperCase()}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Amount Without Tax" />
                  )}
                >
                  <PRZText
                    text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={'You don\'t have access to view amount without tax'} /> : MONEY((record?.invoice_base_price || '0'), record?.org_currency_info?.currency_code)}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>

                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Taxes" />
                  )}
                >
                  <PRZText
                    text={MONEY((record?.invoice_taxes || '0'), record?.org_currency_info?.currency_code)}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Invoice Amount" />
                  )}
                >
                  <PRZText
                    text={(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={'You don\'t have access to view invoice amount'} /> : MONEY((record?.invoice_grand_total || '0'), record?.org_currency_info?.currency_code)}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
                <div className="mobile-list__card_item_status_wrapper">
                  <Tooltip
                    color="white"
                    title={(
                      <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Payment Status" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_item_status"
                      style={{ color: Helpers.getStatusColor(record?.payment_status)?.color }}
                      text={record.payment_status?.replaceAll('_', ' ')?.toProperCase()}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Fulfillment Status" />
                  )}
                >
                  <PRZText
                    className="mobile-list__card_footer__other-status font-11"
                    style={{ color: Helpers.getStatusColor(record?.stock_status).color }}
                    text={record?.stock_status?.replaceAll('_', ' ')?.toProperCase() || '-'}
                  />
                </Tooltip>

                {/* <Tooltip
                  color="white"
                  title={(
                    <PRZText className="mobile-list__card_item__category__tooltip mobile-list__card_item__tooltip_text-color" text="Payment Status" />
                  )}
                >
                  <PRZText
                    className="mobile-list__card_footer__other-status font-11"
                    style={{ color: Helpers.getStatusColor(record?.payment_status)?.color }}
                    text={record.payment_status?.replaceAll('_', ' ')?.toProperCase()}
                  />
                </Tooltip> */}

                <div className="mobile-list__card_footer__actions-button_wrapper">
                  {record?.unicommerce_so_code && (
                    <Popconfirm
                      title={`This ${documentUINames.salesOrderUIName} was last synced on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
                      description={(
                        <span className="font-11">
                          Last sync
                          {' '}
                          {toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                        </span>
                      )}
                      onConfirm={() => {
                        syncSO({
                          tenant_id: user?.tenant_info?.tenant_id,
                          unicommerce_so_codes: [
                            record?.unicommerce_so_code,
                          ],
                        }, () => {
                          setCall(!call);
                        });
                      }}
                      onCancel={() => { }}
                      okText="Sync Again"
                      cancelText="No"
                    >
                      <div className="card_footer__actions-button">
                        <div className="card_footer__actions-button_image__wrapper">
                          <img
                            alt="unicommerce"
                            className="invoice-unicommerce-button card_footer__actions-button_image"
                            src={ucIcon}
                          />
                        </div>
                      </div>
                    </Popconfirm>
                  )}
                  {['CONFIRMED', 'VOID']?.includes(record?.status) && record?.tally_configuration?.sales_voucher_integration && (
                    <Popconfirm
                      title={(record?.tally_warning_message ? record?.tally_warning_message : (record?.tally_updated_at ? ' Invoice is already synced with tally' : ' Invoice is not synced with tally'))}
                      onConfirm={() => syncTallyInvoice(
                        { invoice_id: record?.invoice_id, override_creation: false },
                        () => getInvoice(user?.tenant_info?.org_id,
                          selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','),
                          '',
                          Helpers.getValueFromUrl('page'),
                          Helpers.getValueFromUrl('limit'),
                          '',
                          Helpers.getValueFromUrl('keyword'),
                          Helpers.getValueFromUrl('status'),
                          Helpers.getValueFromUrl('startDate'),
                          Helpers.getValueFromUrl('endDate'),
                          Helpers.getValueFromUrl('department_id')),
                      )}
                      okText={(!record?.tally_warning_message && !record?.tally_updated_at) ? 'Sync' : 'Sync Again'}
                      okButtonProps={{
                        loading: syncTallyInvoiceLoading,
                      }}
                      cancelText="Cancel"
                      icon={record?.tally_warning_message ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                    >
                      <div className="card_footer__actions-button">
                        <div className="img-tally__wrapper card_footer__actions-button_image__wrapper">
                          <img
                            src={TallyPrime}
                            alt="Tally"
                            className="img-tally card_footer__actions-button_image"
                          />
                          {(!record?.tally_updated_at || record?.tally_warning_message) && <div className={`tally-corner-icon actions-button__corner-icon ${record?.tally_warning_message && 'red-indicator'}`}>{!record?.tally_warning_message && <UpCircleTwoTone style={{ fontSize: '10px' }} twoToneColor="#52c41a" />}</div>}
                        </div>
                      </div>
                    </Popconfirm>

                  )}

                  {record?.is_busy_connected
                    && ['CONFIRMED'].includes(record.status)
                    && (
                      <Popconfirm
                        title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? ' Invoice is already synced with Busy' : ' Invoice is not synced with Busy'))}
                        onConfirm={() => pushInvoiceToBusy(
                          { invoice_id: record?.invoice_id },
                          () => getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
                            Helpers.getValueFromUrl('status'),
                            Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), true),
                        )}
                        okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                        okButtonProps={{
                          loading: pushInvoiceToBusyLoading,
                        }}
                        cancelText="Cancel"
                        icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                      >
                        <div className="card_footer__actions-button">
                          <div className="card_footer__actions-button_image__wrapper">
                            <img
                              src={Busy}
                              alt="Tally"
                              className="img-tally card_footer__actions-button_image"
                            />
                            {(!record?.busy_sync_at || record?.busy_sync_error) && (
                              <div className={`tally-corner-icon actions-button__corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>
                                {!record?.busy_sync_error && (<UpCircleTwoTone style={{ fontSize: '10px' }} twoToneColor="#52c41a" />)}
                              </div>
                            )}
                          </div>
                        </div>
                      </Popconfirm>
                    )}

                  {record?.shopify_order_id && (
                    <div className="card_footer__actions-button">
                      <div className="img-shopify__wrapper card_footer__actions-button_image__wrapper">
                        <img
                          src={ShopifyIcon}
                          alt="Shopify"
                          className="img-shopify card_footer__actions-button_image"
                        />
                      </div>
                    </div>
                  )}

                  {user?.tenant_info?.zoho_branch_id && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && (
                    <Fragment>
                      {record?.status === 'CONFIRMED' && (
                        <div className="card_footer__actions-button">
                          {(record?.zoho_invoice_id)
                            ? (
                              <Tooltip
                                title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                                overlayClassName="font-11"
                              >
                                <a
                                  href={`https://books.zoho.in/app#/invoices/${record?.zoho_invoice_id}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                    <img
                                      src={ZohoBooks}
                                      alt="Zoho"
                                      className="img-zoho card_footer__actions-button_image"
                                    />
                                    <div className="green-indicator" />
                                  </div>
                                </a>
                              </Tooltip>
                            )
                            : (
                              <div>
                                {!['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                                  <Popconfirm
                                    title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Invoice is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                                    onConfirm={() => syncInvoice(
                                      { invoice_id: record?.invoice_id },
                                      () => getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
                                        Helpers.getValueFromUrl('status'),
                                        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id')),
                                    )}
                                    okText="Sync again"
                                    okButtonProps={{
                                      loading: syncInvoiceLoading,
                                    }}
                                    cancelText="Cancel"
                                  >
                                    <div className="img-zoho__wrapper card_footer__actions-button_image__wrapper">
                                      <img
                                        src={ZohoBooks}
                                        alt="Zoho"
                                        className="img-zoho img-zoho__disabled card_footer__actions-button_image"
                                      />
                                      <div className="green-indicator red-indicator" />
                                    </div>
                                  </Popconfirm>
                                )}
                              </div>
                            )}
                        </div>
                      )}
                    </Fragment>
                  )}
                </div>

              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedInvoice(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'INVOICE #',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => (
          <div className="column-number__wrapper min-width-70">
            <div className="invoice-column__wrapper">
              <div>{record?.invoice_number}</div>
              {user?.tenant_info?.global_config?.settings?.marketplace_enabled && record?.is_marketplace_invoice && (
                <div className="mp-status" style={{ backgroundColor: '#f58428' }}>
                  MP
                </div>
              )}
              {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && user?.user_tenants?.find((tenant) => record?.tenant_id === tenant?.tenant_id)?.is_e_way_bill_enabled && (
                <Tooltip
                  title={record?.e_invoice_status === 'PUSHED' ? 'Invoice pushed to IRP' : 'Invoice yet-to-be pushed to IRP'}
                >
                  <div
                    style={{ color: record?.e_invoice_status === 'PUSHED' ? '#52c41a' : '#ee3a49' }}
                    className="irp-status"
                  >
                    <FileProtectOutlined />
                  </div>
                </Tooltip>
              )}
            </div>
            {user?.tenant_info?.sales_config?.addons?.e_invoicing?.is_active && user?.user_tenants?.find((tenant) => record?.tenant_id === tenant?.tenant_id)?.is_e_way_bill_enabled && record?.e_invoice_status === 'PUSHED' && (
              <span
                className="irn-action"
                onClick={() => {
                  navigator.clipboard.writeText(record?.irn);
                  notification.success({
                    message: 'IRN Copied',
                    placement: 'top',
                    duration: 4,
                  });
                }}
              >
                Copy IRN
              </span>
            )}
          </div>
        ),
        className: !visibleColumns?.INVOICE_NO?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'SOURCE',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.source?.replace(/_/g, ' ')?.toProperCase()} />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SOURCE?.visible ? 'display-none' : '',
      },
      {
        title: 'SO #',
        render: (text, record) => {
          let content = null;

          if (Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user)) {
            if (record?.order_type !== "PACKING_SLIP") {
              // Check if the record has an order ID
              if (record?.order_id) {
                content = (
                  <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                    {record?.sales_order_number}
                  </Link>
                );
              }
            }
          }
          return (
            <div className="min-width-50">
              <div className="associated-entity">
                {content}
              </div>
              <div className="associated-entity">
                {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN,
                  Helpers.permissionTypes.READ, user)
                  ? (record?.delivery_challan_id ? (
                    <Link to={`/inventory/delivery-challan/view/${record?.delivery_challan_id}`} target="_blank">
                      {record?.dc_number}
                    </Link>
                  ) : '') : (record?.order_id || '')}
              </div>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SO_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'PS #',
        render: (text, record) => {
          let content = null;
          if (Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ, user)) {
            if (record?.order_type === 'PACKING_SLIP') {
              // Check if the record has an order ID
              if (record?.order_id) {
                content = (
                  <Link to={`/sales/packing-slip/view/${record?.order_id}`} target="_blank">
                    {record?.sales_order_number}
                  </Link>
                );
              }
            }
          }
          return (
            <div className="min-width-50">
              <div className="associated-entity">
                {content}
              </div>
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PS_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'WO #',
        render: (text, record) => (
          <div className="min-width-50">
            <div className="associated-entity">
              {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
                Helpers.permissionTypes.READ, user)
                ? (record?.subcontractor_po_details?.po_id ? (
                  <Link to={`/approval?type=po&id=${record?.subcontractor_po_details?.po_id}`} target="_blank">
                    {record?.subcontractor_po_details?.po_number}
                  </Link>
                ) : '') : (record?.subcontractor_po_details?.po_id || '')}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PO_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
              Helpers.permissionTypes.READ, user)
              ? (record?.customer_info?.customer_name ? (
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                </Link>
              ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: 'GATE DOCUMENT NUMBER',
        width: '200px',
        render: (record) => {
          const gateDocNumber = record?.ref_gate_document;

          const otherDocs = (
            <div>
              {
                gateDocNumber?.slice(2).map((document, i) => (
                  <div className="other-uom-stock" key={i}>
                    <div
                      onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      {document?.gate_document_number}
                    </div>
                  </div>
                ))
              }
            </div>
          );
          return (
            <Popover
              placement="bottom"
              content={gateDocNumber?.length > 2 && otherDocs}
              trigger="hover"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <div className="min-width-150">
                {gateDocNumber?.slice(0, 2)?.map((document) => (
                  <Link
                    to={`/logistic/gate-document/view/${document?.gate_document_id}`}
                    target="_blank"
                    key={document?.gate_document_id}
                  >
                    <div className="associated-entity">
                      {document?.gate_document_number}
                    </div>
                  </Link>
                ))}
                {document?.length > 2 && (
                  <H3Text
                    className="table-subscript-grey"
                    text={`and ${document.length - 2} more`}
                  />
                )}
              </div>
            </Popover>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.GATE_DOCUMENT?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className="min-width-130">
            {record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (item) => (
          <div className="min-width-50">
            {item?.item_count || 0}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div className="min-width-100">
            <div className="column-date">
              {dayjs(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'INVOICE DATE',
        render: (record) => (
          <div className="column-date min-width-100">
            {dayjs(record?.invoice_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.INVOICE_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'AMOUNT WITHOUT TAX',
        render: (item, record) => (
          <div className="column-amount min-width-150">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view amount without tax"} /> : MONEY((record?.invoice_base_price || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AMOUNT_WITHOUT_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        render: (item, record) => (
          <div className="column-amount min-width-50">
            {MONEY((record?.invoice_taxes || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TAXES?.visible ? 'display-none' : '',
      },
      {
        title: 'INVOICE AMOUNT',
        render: (item, record) => (
          <div className="min-width-115">
            {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view invoice amount"} /> : MONEY((record?.invoice_grand_total || '0'), record?.org_currency_info?.currency_code)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.AMOUNT_WITH_TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'DUE DATE',
        render: (record) => (
          <div className="min-width-70">
            <div className="column-date">
              {record?.invoice_due_date ? toISTDate(record?.invoice_due_date).format('DD/MM/YYYY') : '-'}
              {' '}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.DUE_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'PAYMENT STATUS',
        render: (item) => (
          <div
            className="shopify-order-statuses min-width-115"
            style={{ color: Helpers.getStatusColor(item.payment_status).color }}
          >
            {item.payment_status?.replaceAll('_', ' ')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PAYMENT_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'FULFILLMENT STATUS',
        render: (item) => (
          <div
            className="sopify-order-statuses min-width-130"
            style={{ color: Helpers.getStatusColor(item?.stock_status).color }}
          >
            {item?.stock_status?.replaceAll('_', ' ') || '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FULFILLMENT_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <Fragment>
            <div className="table-labels__list min-width-70">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        tableColumns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    const addAlpha = (color, opacity) => {
      // coerce values so ti is between 0 and 1.
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16)?.toUpperCase();
    };
    tableColumns.splice(4, 0, {
      title: 'SHOPIFY #',
      key: 'action2',
      render: (text, record) => (
        <div className="min-width-70">{user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.shopify_location_id && (
          <div>
            {(record?.shopify_order_id)
              ? (
                <Tooltip
                  title={`Order placed on ${dayjs(record?.shopify_created_at).format('DD/MM/YYYY hh:mm A')}`}
                  overlayClassName="font-12"
                  placement="topRight"
                >
                  <a
                    href={`https://admin.shopify.com/store/${record?.shopify_shop_name?.split('.')?.[0]}/orders/${record?.shopify_order_id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {record?.shopify_order_number}
                  </a>
                </Tooltip>
              )
              : '-'}
          </div>
        )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      className: !visibleColumns?.SHOPIFY_CODE?.visible ? 'display-none' : '',
    });
    tableColumns.push({
      title: '',
      key: 'action',
      fixed: 'right',
      render: (record) => (
        <div className="list__actions">
          {record?.unicommerce_so_code && (
            <Popconfirm
              placement="topRight"
              title={`This ${documentUINames.salesOrderUIName} was last synced on ${record?.unicommerce_last_sync && toISTDate(record?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`}
              onConfirm={() => {
                syncSO({
                  tenant_id: user?.tenant_info?.tenant_id,
                  unicommerce_so_codes: [
                    record?.unicommerce_so_code,
                  ],
                }, () => {
                  setCall(!call);
                });
              }}
              okText="Sync Again"
              cancelText="No"
            >
              <div className="list__actions-button">
                <img
                  alt="unicommerce"
                  className="invoice-unicommerce-button"
                  src={ucIcon}
                />
              </div>
            </Popconfirm>
          )}
          {
            ['CONFIRMED', 'VOID']?.includes(record?.status) && record?.tally_configuration?.sales_voucher_integration && (
              // eslint-disable-next-line react/jsx-indent
              <div>
                <Popconfirm
                  placement="topRight"
                  title={(record?.tally_warning_message ? record?.tally_warning_message : (record?.tally_updated_at ? ' Invoice is already synced with tally' : ' Invoice is not synced with tally'))}
                  onConfirm={() => syncTallyInvoice(
                    { invoice_id: record?.invoice_id, override_creation: false },
                    () => getInvoice(user?.tenant_info?.org_id,
                      selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','),
                      '',
                      Helpers.getValueFromUrl('page'),
                      Helpers.getValueFromUrl('limit'),
                      '',
                      Helpers.getValueFromUrl('keyword'),
                      Helpers.getValueFromUrl('status'),
                      Helpers.getValueFromUrl('startDate'),
                      Helpers.getValueFromUrl('endDate'),
                      Helpers.getValueFromUrl('department_id')),
                  )}
                  okText={(!record?.tally_warning_message && !record?.tally_updated_at) ? 'Sync' : 'Sync Again'}
                  okButtonProps={{
                    loading: syncTallyInvoiceLoading,
                  }}
                  cancelText="Cancel"
                  icon={record?.tally_warning_message ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                >
                  <div className="list__actions-button img-tally__wrapper">
                    <img
                      src={TallyPrime}
                      alt="Tally"
                      className="img-tally"
                    />
                    {(!record?.tally_updated_at || record?.tally_warning_message) && <div className={`tally-corner-icon  ${record?.tally_warning_message && 'red-indicator'}`}>{!record?.tally_warning_message && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
                  </div>
                </Popconfirm>
              </div>
            )
          }

          {
            record?.is_busy_connected && (
              // eslint-disable-next-line react/jsx-indent
              <div className="list__actions-button img-tally__wrapper">
                {['CONFIRMED'].includes(record.status) && (
                  <Popconfirm
                    placement="topRight"
                    title={(record?.busy_sync_error ? record?.busy_sync_error : (record?.busy_voucher_id ? ' Invoice is already synced with Busy' : ' Invoice is not synced with Busy'))}
                    onConfirm={() => pushInvoiceToBusy(
                      { invoice_id: record?.invoice_id },
                      () => getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
                        Helpers.getValueFromUrl('status'),
                        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), true),
                    )}
                    okText={(!record?.busy_sync_error && !record?.busy_voucher_id) ? 'Sync' : 'Sync Again'}
                    okButtonProps={{
                      loading: pushInvoiceToBusyLoading,
                    }}
                    cancelText="Cancel"
                    icon={record?.busy_sync_error ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                  >

                    <img
                      src={Busy}
                      alt="Tally"
                      className="img-tally"
                    />
                    {(!record?.busy_sync_at || record?.busy_sync_error) && <div className={`tally-corner-icon  ${record?.busy_sync_error && 'red-indicator'}`}>{!record?.busy_sync_error && <UpCircleTwoTone twoToneColor="#52c41a" />}</div>}
                  </Popconfirm>
                )}
              </div>
            )
          }
          {record?.shopify_order_id && (
            <div className="list__actions-button img-shopify__wrapper">
              <img
                src={ShopifyIcon}
                alt="Shopify"
                className="img-shopify"
              />
            </div>
          )}
          {user?.tenant_info?.zoho_branch_id && user?.user_tenants?.find((item) => item?.tenant_id === record?.tenant_id)?.zoho_branch_id && (
            <Fragment>
              {record?.status === 'CONFIRMED' && (
                <div className="list__actions-button">
                  {(record?.zoho_invoice_id)
                    ? (
                      <Tooltip
                        title={toISTDate(record?.zoho_updated_at).format('DD/MM/YYYY hh:mm A')}
                        overlayClassName="font-12"
                        placement="topRight"
                      >
                        <a
                          href={`https://books.zoho.in/app#/invoices/${record?.zoho_invoice_id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="img-zoho__wrapper">
                            <img
                              src={ZohoBooks}
                              alt="Zoho"
                              className="img-zoho"
                            />
                            <div className="green-indicator" />
                          </div>
                        </a>
                      </Tooltip>
                    )
                    : (
                      <div>
                        {!['SENT_FOR_APPROVAL', 'DRAFT', 'VOID', 'CANCELLED'].includes(record?.status) && (
                          <Popconfirm
                            placement="topRight"
                            title={(record?.zoho_warning_message === null || record?.zoho_warning_message === '') ? 'This Invoice is not synced with Zoho Books.' : `${record?.zoho_warning_message}`}
                            onConfirm={() => syncInvoice(
                              { invoice_id: record?.invoice_id },
                              () => getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
                                Helpers.getValueFromUrl('status'),
                                Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id')),
                            )}
                            okText="Sync again"
                            okButtonProps={{
                              loading: syncInvoiceLoading,
                            }}
                            cancelText="Cancel"
                          >
                            <div className="img-zoho__wrapper">
                              <img
                                src={ZohoBooks}
                                alt="Zoho"
                                className="img-zoho img-zoho__disabled"
                              />
                              <div className="green-indicator red-indicator" />
                            </div>
                          </Popconfirm>
                        )}
                      </div>
                    )}
                </div>
              )}
            </Fragment>
          )}
          <div className="list__actions-button list__actions-status-selector">
            <SelectStatus
              selectedCustomStatus={record?.custom_status_id}
              hideTitle
              tenantId={selectedTenant?.join(',')}
              posibleStatuses={record?.possible_status ? [record?.custom_status_info, ...record?.possible_status] : [record?.custom_status_info]}
              onChange={(value) => {
                updateInvoiceStatus({
                  status: value?.type,
                  secondary_status: value?.status_name,
                  invoice_id: record?.invoice_id,
                  custom_status_id: value?.custom_status_id,
                }, () => {
                  setCall(!call);
                });
              }}
              disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(record?.custom_status_info?.type) || !record?.custom_status_id}
              customStyle={{
                color: record?.custom_status_info?.color_code,
                backgroundColor: addAlpha(record?.custom_status_info?.color_code, 0.9),
                fontSize: '11px',
                height: '50px',
              }}
              dropdownAlign={{ offset: [0, 18] }}
            />
          </div>

          {!isPortrait && (
            <React.Fragment>
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  history.push(`/sales/invoice/view/${record?.invoice_id}`);
                }}
              >
                View
              </div>
              <Tooltip
                placement="topLeft"
                title="Make a Copy"
              >
                <div
                  className={`list__actions-button ${(record?.shopify_order_id || record?.unicommerce_so_code) ? 'list__actions-button-download-disabled' : ''}`}
                  onClick={() => {
                    if (!record?.shopify_order_id && !record?.unicommerce_so_code) {
                      history.push({
                        pathname: '/sales/invoices/create',
                        state: { cloneInv: record?.invoice_id, selectedTenantIdInv: record?.tenant_id },
                      });
                    }
                  }}
                >
                  <CopyOutlined
                    style={{
                      fontSize: '16px',
                    }}
                  />
                </div>
              </Tooltip>
            </React.Fragment>
          )}
        </div>
      ),
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isMobile,
      className: 'list__actions-column',
    });
    return tableColumns.filter((item) => !item.hidden);
  };

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-inv'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'shopify_keyword',
        filter_value: (Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword'))) || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'payment_status',
        filter_value: Helpers.getValueFromUrl('payment_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: Helpers.getValueFromUrl('custom_status') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: Number(Helpers.getValueFromUrl('custom_status_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'source',
        filter_value: Helpers.getValueFromUrl('source') ? Helpers.getValueFromUrl('source')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'stock_status',
        filter_value: Helpers.getValueFromUrl('stock_status') ? Helpers.getValueFromUrl('stock_status')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'marketplace_invoice',
        filter_value: Boolean(Helpers.getValueFromUrl('marketplace_invoice')) || false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Number(Helpers.getValueFromUrl('department_id')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice);
    return [
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'shopify_keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'payment_status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'source',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'stock_status',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'label',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'marketplace_invoice',
        filter_value: false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'accountManager',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.INVOICES,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  const pushParamsToUrl = (page, currentLimit, word, status, paymentStatuses, currentTenant, currentStartDate, currentEndDate, currentDepartment, customStatus, customStatusId, shopifyWord, selectedMarketplaceInvoice, tags, accountManager, createdFrom, selectedStockStatus, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    url += '&list_screen=true';
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (word) url += `&keyword=${word}`;
    if (shopifyWord) url += `&shopify_keyword=${encodeURIComponent(shopifyWord)}`;
    if (status) url += `&status=${status}`;
    if (customStatus) url += `&custom_status=${customStatus}`;
    if (customStatusId) url += `&custom_status_id=${customStatusId}`;
    if (paymentStatuses) url += `&payment_status=${paymentStatuses}`;
    if (currentTenant.length > 0) url += `&tenant=${currentTenant}`;
    if (currentStartDate) url += `&startDate=${currentStartDate}`;
    if (currentEndDate) url += `&endDate=${currentEndDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (currentDepartment) url += `&department_id=${currentDepartment}`;
    if (selectedMarketplaceInvoice) url += `&marketplace_invoice=${selectedMarketplaceInvoice}`;
    if (createdFrom.length > 0) url += `&source=${createdFrom}`;
    if (selectedStockStatus) url += `&stock_status=${selectedStockStatus}`;
    if (tags.length > 0) url += `&label=${tags}`;
    if (accountManager.length > 0) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
        // return {
        //   keyword: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'keyword' }),
        //   limit: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'limit' }),
        //   page: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'page' }),
        //   shopify_keyword: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'shopify_keyword' }),
        //   payment_status: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'payment_status' }),
        //   custom_status: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'custom_status' }),
        //   custom_status_id: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'custom_status_id' }),
        //   source: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'source' }),
        //   stock_status: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'stock_status' }),
        //   tenant: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'tenant' }),
        //   label: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'label' }),
        //   marketplace_invoice: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'marketplace_invoice' }),
        //   startDate: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate' }),
        //   endDate: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'endDate' }),
        //   accountManager: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'accountManager' }),
        //   department_id: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'department_id' }),
        // };
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setShopifySearchKeyword(tempFilterValues.shopify_keyword);
        setKeyword(tempFilterValues.keyword);
        setPaymentStatus(tempFilterValues.payment_status);
        setSelectedCustomStatus(tempFilterValues.custom_status);
        setSelectedCustomStatusId(tempFilterValues.custom_status_id);
        setShopifyKeyword(tempFilterValues.shopify_keyword);
        setSource(tempFilterValues.source);
        setStockStatus(tempFilterValues.stock_status);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedTag(tempFilterValues.label);
        setMarketplaceInvoice(tempFilterValues.marketplace_invoice);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedDepartment(tempFilterValues.department_id);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(tempFilterValues.department_id || null || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(tempFilterValues.department_id || null);
        }

        // if (user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)) {
        //   setSelectedAssignee([{
        //     userId: user?.user_id,
        //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
        //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
        //   }]);
        // } else {
        //   setSelectedAssignee(tempFilterValues.accountManager || []);
        // }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setShopifySearchKeyword(Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setPaymentStatus(Helpers.getValueFromUrl('payment_status'));

      // // setSelectedStatus(Helpers.getValueFromUrl('status'));

      // setSelectedCustomStatus(Helpers.getValueFromUrl('custom_status'));
      // setSelectedCustomStatusId(Number(Helpers.getValueFromUrl('custom_status_id')) || '');
      // setShopifyKeyword(Helpers.getValueFromUrl('shopify_keyword') && decodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')));
      // setSelectedEmails([user?.email]);

      // // setSelectedStatus(Helpers.getValueFromUrl('status'));

      // // setSource(Helpers.getValueFromUrl('source'));

      // setSource(Helpers.getValueFromUrl('source') ? Helpers.getValueFromUrl('source')?.split(',')?.map((item) => item) : []);
      // setStockStatus(Helpers.getValueFromUrl('stock_status') ? Helpers.getValueFromUrl('stock_status')?.split(',')?.map((item) => item) : []);
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedTag(Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : []);
      // setMarketplaceInvoice(Helpers.getValueFromUrl('marketplace_invoice') || false);
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
      //   userId: parseInt(item),
      //   title: `${orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name}`?.trim(),
      //   identity: orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
      // })) : []);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
      // }
      // setIsUserReady(true);
    }

    // if (user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)) {
    //   setSelectedAssignee([{
    //     userId: user?.user_id,
    //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
    //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
    //   }]);
    // } else {
    //   setSelectedAssignee([]);
    // }

    setSelectedFilterView(systemDefaultUserView);

    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      getCustomStatus({
        entityName: 'INVOICE',
        orgId: user?.tenant_info?.org_id,
      }, () => { });
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, paymentStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, selectedCustomStatusId, shopifySearchKeyword && shopifySearchKeyword.replace(/\s/g, ''), marketplaceInvoice, selectedTag, selectedAssignee, source, stockStatus, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'INVOICE',
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getDocCFV2(payload);
      getInvoice(user?.tenant_info?.org_id, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)?.join(','), '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'),
        Helpers.getValueFromUrl('status'),
        Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), Helpers.getValueFromUrl('department_id'), Helpers.getValueFromUrl('list_screen'), Helpers.getValueFromUrl('payment_status'), '', Helpers.getValueFromUrl('custom_status'), Helpers.getValueFromUrl('shopify_keyword') && encodeURIComponent(Helpers.getValueFromUrl('shopify_keyword')), Helpers.getValueFromUrl('label'), () => {
          setIsModalOpen(false);
        }, Helpers.getValueFromUrl('marketplace_invoice') || false, Helpers.getValueFromUrl('accountManager'), Helpers.getValueFromUrl('source'), Helpers.getValueFromUrl('stock_status'));
    }
  }, [searchKeyword, currentPage, selectedStatus, paymentStatus, selectedTenant, selectedDepartment, startDate, endDate, selectedCustomStatus, shopifySearchKeyword, limit, call, marketplaceInvoice, selectedTag, selectedAssignee, source, stockStatus, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.invoice_id }));
    }
    return [];
  };

  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const payload = {
      tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      payment_status: Helpers.getValueFromUrl('payment_status'),
      from_date: Helpers.getValueFromUrl('startDate'),
      to_date: Helpers.getValueFromUrl('endDate'),
      columns: stringsString,
      custom_fields: numbersString,
      emails: selectedEmails,
      type: 'send_email',
      level: reportType,
      tags: Helpers.getValueFromUrl('label'),
      fulfillment_status: Helpers.getValueFromUrl('stock_status'),
      custom_status: Helpers.getValueFromUrl('custom_status'),
      department_id: Helpers.getValueFromUrl('department_id'),
      user_id: user?.user_id,
    };
    if (!downloadInvoiceListLoading) {
      downloadInvoiceList(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  const documentOptions = [
    { value: "SALES_ORDER", label: documentUINames.salesOrderUIName },
    { value: "DELIVERY_CHALLAN", label: "Delivery Challan" },
    { value: "MANUFACTURING_ORDER", label: "Manufacturing Order" },
    { value: "ADHOC", label: "ADHOC" },
    { value: "SHOPIFY", label: "Shopify" },
    { value: "UNICOMMERCE", label: "Unicommerce" },
  ];

  const statusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "PARTIAL", label: "Partially Completed" },
    { value: "COMPLETED", label: "Completed" },
  ];

  return (
    <Fragment>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={ShopifyIcon}
              width={24}
              height={24}
              style={{ marginRight: 10 }}
            />
            <div>Search for Shopify Order</div>
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
          setShopifyKeyword(null);
          setShopifySearchKeyword(null);
        }}
        onCancel={() => {
          setIsModalOpen(false);
          setShopifyKeyword(null);
          setShopifySearchKeyword(null);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <div className="section-search-bar">
              <input
                value={shopifyKeyword}
                placeholder="Search by comma seprated Shopify Order Id... eg.#1135,#1146"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setShopifySearchKeyword(e.target.value);
                    setCurrentPage(1);
                  }
                }}
                onChange={(event) => {
                  setShopifyKeyword(event.target.value);
                }}
              />
              {!getInvoiceLoading ? (
                <H3Image
                  src={searchIcon}
                  className="section-search-bar__icon"
                  alt="search"
                  onClick={() => {
                    setShopifySearchKeyword(keyword);
                    setCurrentPage(1);
                  }}
                />
              ) : (
                <LoadingOutlined />
              )}
            </div>
          </div>
        </div>
      </Modal>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Invoice..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
                {!!user?.user_tenants?.filter((userTenant) => userTenant?.shopify_location_id)?.length && (
                  <div className="trigger-modal-btn">
                    <H3Text
                      text={(
                        <div className="new-action-button-wrapper" onClick={() => setIsModalOpen(true)}>
                          <Fragment>
                            <H3Image src={ShopifyIcon} className="action-button-icon" />
                            <div className="action-button-text">Search</div>
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                )}
              </div>
              <div className="doc-list__header-wrapper__right">
                {user?.user_tenants?.find((item) => item?.shopify_location_id) && Helpers.getPermission(Helpers.permissionEntities.INVOICE,
                  Helpers.permissionTypes.UPDATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ Returns"
                        onClick={() => setShowBulkReturnsDrawer(true)}
                        customClass="add-button"
                      />
                    </div>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Invoice"
                      onClick={() => {
                        history.push('/sales/invoices/create');
                      }}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;
                    // const tempFilterValues = {
                    //   keyword: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'keyword' }),
                    //   limit: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'limit' }),
                    //   page: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'page' }),
                    //   shopify_keyword: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'shopify_keyword' }),
                    //   payment_status: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'payment_status' }),
                    //   custom_status: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'custom_status' }),
                    //   custom_status_id: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'custom_status_id' }),
                    //   source: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'source' }),
                    //   stock_status: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'stock_status' }),
                    //   tenant: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'tenant' }),
                    //   label: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'label' }),
                    //   marketplace_invoice: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'marketplace_invoice' }),
                    //   startDate: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate' }),
                    //   endDate: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'endDate' }),
                    //   accountManager: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'accountManager' }),
                    //   department_id: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'department_id' }),
                    // };


                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;

                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setShopifySearchKeyword(tempFilterValues.shopify_keyword);
                    setKeyword(tempFilterValues.keyword);
                    setPaymentStatus(tempFilterValues.payment_status);
                    setSelectedCustomStatus(tempFilterValues.custom_status);
                    setSelectedCustomStatusId(tempFilterValues.custom_status_id);
                    setShopifyKeyword(tempFilterValues.shopify_keyword);
                    setSource(tempFilterValues.source);
                    setStockStatus(tempFilterValues.stock_status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedTag(tempFilterValues.label);
                    setMarketplaceInvoice(tempFilterValues.marketplace_invoice);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setSelectedDepartment(tempFilterValues.department_id);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.INVOICES}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {shopifySearchKeyword && (
                  <Tag closable onClose={() => { setShopifySearchKeyword(''); setShopifyKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for shopify# -
                    &nbsp;
                    <span><b>{shopifySearchKeyword.replace(/\s/g, '')}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); setSelectedCustomStatus(null); setSelectedCustomStatusId(null); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedCustomStatus && (
                  <Tag closable onClose={() => { setSelectedCustomStatus(null); setCurrentPage(1); setSelectedCustomStatusId(null); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedCustomStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {paymentStatus && (
                  <Tag closable onClose={() => { setPaymentStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Payment Status -
                    &nbsp;
                    <span><b>{paymentStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}

                {source && source?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSource(source?.filter((tId, ind) => ind !== index));
                    }}
                    color="#2d7df7"
                  >
                    Source -
                    &nbsp;
                    <span>
                      <b>{item?.replaceAll('_', ' ')?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {stockStatus && stockStatus?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setStockStatus(stockStatus?.filter((tId, ind) => ind !== index));
                    }}
                    color="#2d7df7"
                  >
                    Source -
                    &nbsp;
                    <span>
                      <b>{item?.replaceAll('_', ' ')?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}

                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}

                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(invoices && invoices?.data?.count) ? invoices?.data?.count : '0'} Total Invoices`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">

                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                              setCurrentPage(1)
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                            disabled={user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings?.restrict_invoice_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_invoice)}
                          />
                        </div>

                        {
                          invoices && invoices?.data?.count > 0
                          && (
                            <Popover
                              placement="bottom"
                              trigger="click"
                              title={<div className="download-btn-popover__title">Please provide your email address</div>}
                              open={openPopover}
                              onOpenChange={() => setOpenPopover(!openPopover)}
                              content={(
                                <React.Fragment>
                                  <div>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      mode="tags"
                                      filterOption={false}
                                      value={selectedEmails}
                                      onChange={(value) => setSelectedEmails(value)}
                                      disabled={downloadInvoiceListLoading}
                                      maxTagCount="responsive"
                                      style={{
                                        width: '300px',
                                        fontSize: '13px',
                                        paddingTop: '2px',
                                        height: 'auto !important',
                                      }}
                                    >

                                      {selectedEmails.length > 0 ? (
                                        selectedEmails.map((item) => (
                                          <Option key={item} value={item}>
                                            {item}
                                          </Option>
                                        ))
                                      ) : (
                                        <Option key={user?.email} value={user?.email}>
                                          {user?.email}
                                        </Option>
                                      )}

                                    </PRZSelect>
                                  </div>
                                  <div className="mg-top-10">
                                    <Radio.Group
                                      onChange={(event) => setReportType(event?.target?.value)}
                                      disabled={downloadInvoiceListLoading}
                                      value={reportType}
                                    >
                                      <Space direction="vertical">
                                        <Radio key="1" value="document_level">Invoice Data</Radio>
                                        <Radio key="2" value="line_level">Invoice Items Data</Radio>
                                      </Space>
                                    </Radio.Group>

                                  </div>
                                  <div className="mg-top-10">
                                    <H3Button
                                      text="Send"
                                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                      onClick={() => { downloadHandler(); }}
                                      customClass="email-submit"
                                      isLoading={downloadInvoiceListLoading}
                                      disabled={downloadInvoiceListLoading}
                                    >
                                      Send

                                    </H3Button>
                                  </div>

                                </React.Fragment>
                              )}
                            >
                              <div
                                className={`download-btn ${downloadInvoiceListLoading ? 'download-btn__disabled' : ''}`}
                                onClick={() => {
                                  setOpenPopover(true);
                                }}
                              >
                                <H3Text
                                  text={(
                                    <FontAwesomeIcon icon={faDownload} />
                                  )}
                                  className="action-button"
                                />
                              </div>
                            </Popover>

                          )
                        }
                        {selectedRowKeys?.length > 0 && (
                          <BulkInvoiceActions
                            selectedCustomStatus={selectedCustomStatus}
                            selectedCustomStatusId={selectedCustomStatusId}
                            setSelectedCustomStatusId={(val) => setSelectedCustomStatusId(val)}
                            selectedRowKeys={selectedRowKeys}
                            selectedRows={selectedRows}
                            callback={() => {
                              setSelectedRowKeys([]);
                              setSelectedRows([]);
                              setCall(!call);
                            }}
                          />
                        )}
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        <div className="doc-list__action-buttons" onClick={() => setShowFilters(true)}>
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns)?.filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-inv', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns)?.filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns)?.filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-inv', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                loading={getInvoiceLoading || syncSOLoading || getDocCFV2Loading || updateInvoiceStatusLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!getDataSource(invoices?.data?.invoices)?.length ? { x: 'max-content', y: 'calc(100dvh - 170px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(invoices?.data?.invoices)?.length}
                columns={getInvoiceColumns()}
                dataSource={getDataSource(invoices?.data?.invoices) || []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: invoices ? invoices?.data?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50', '100'],
                  }
                }
                rowSelection={!isMobileOrPortrait ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  selectedRowKeys,
                } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showBulkReturnsDrawer}
        width="460px"
        mask
        onClose={() => setShowBulkReturnsDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '415px' }}>
            <H3Text text="Create Bulk Returns" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowBulkReturnsDrawer(false)} />
          </div>
        </div>
        <BulkReturns callback={() => {
          history.push('/analytics/bulkUpload');
          setShowBulkReturnsDrawer(false);
        }}
        />
      </Drawer>
      <Drawer
        open={showFilters}
        width="340px"
        mask
        onClose={() => setShowFilters(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '295px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="filter-drawer__wrapper">
          <div className="filter__container">
            <div className="filter__title"> Select Business Unit </div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              isMultiple
              noDropdownAlign
              onChange={(value) => {
                setCurrentPage(1);
                setSelectedTenant(value);
              }}
              placeholder="Select Business Unit"
              hideTitle
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ)}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Department </div>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={Number(selectedDepartment) || ''}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value?.department_id.toString() || '');
                setCurrentPage(1);
              }}
              disabled={departmentLevelVisibility}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Order Status </div>
            <PRZSelect
              value={selectedCustomStatus}
              onChange={(value) => {
                const requiredStatus = customStatusInvoice?.statuses?.filter((status) => status?.status_name === value)[0];
                setSelectedCustomStatus(requiredStatus?.status_name);
                setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                setSelectedRowKeys(null);
                setSelectedRows(null);
                setCurrentPage(1);
              }}
              placeholder="Order Status"
            >
              <Option key={null} value={null}> All Status</Option>
              {customStatusInvoice?.statuses?.map((item) => (<Option key={item?.custom_status_id} value={item?.status_name}>{item?.status_name?.split('_')?.join(' ')?.toProperCase()}</Option>))}
            </PRZSelect>
          </div>
          <div className="filter__container">
            <div className="filter__title"> Payment Status </div>
            <PRZSelect
              value={paymentStatus}
              onChange={(value) => {
                setPaymentStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Order Payment Status"
              options={paymentStatues}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Source </div>
            <PRZSelect
              value={source}
              onChange={(value) => {
                setSource(value);
                setCurrentPage(1);
              }}
              placeholder="Select Source"
              mode="multiple"
              maxTagCount="responsive"
              options={documentOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Select Labels </div>
            <TagSelector
              filter
              entityType="INVOICE"
              selectedTags={selectedTag}
              showSearch
              showAll={false}
              noDropdownAlign
              isMultiple
              onChange={(value) => {
                setCurrentPage(1);
                setSelectedTag(value);
              }}
              placeholder="Select Label"
              hideTitle
              hideCSS
            />
          </div>
          <div className="filter__container">
            <div className="filter__title">Fulfillment Status</div>
            <PRZSelect
              value={stockStatus}
              onChange={(value) => {
                setStockStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Stock Status"
              mode="multiple"
              maxTagCount="responsive"
              options={statusOptions}
            />
          </div>
          <div className="filter__container">
            <div className="filter__title"> Marketplace Invoice </div>
            <Switch
              checked={marketplaceInvoice}
              onChange={() => setMarketplaceInvoice(!marketplaceInvoice)}
            />
          </div>
        </div>
      </Drawer>

      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedInvoice?.invoice_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedInvoice?.custom_fields}
          documentData={selectedInvoice}
          fields={ListScreenKeys({
            documentData: selectedInvoice, user,
          })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, InvoiceReducers, UnicommerceIntegrationReducers, CFV2Reducers, DepartmentReducers, ZohoIntegrationReducers, TallyIntegrationReducers, CustomStatusReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getInvoiceLoading: InvoiceReducers.getInvoiceLoading,
  invoices: InvoiceReducers.invoices,
  syncInvoiceLoading: ZohoIntegrationReducers.syncInvoiceLoading,
  syncSOLoading: UnicommerceIntegrationReducers.syncSOLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocInvoice,
  departments: DepartmentReducers.departments,
  syncTallyInvoiceLoading: TallyIntegrationReducers.syncTallyInvoiceLoading,
  customStatusInvoice: CustomStatusReducers.customStatusInvoice,
  downloadInvoiceLoading: InvoiceReducers.downloadInvoiceLoading,
  updateInvoiceStatusLoading: InvoiceReducers.updateInvoiceStatusLoading,
  downloadInvoiceListLoading: InvoiceReducers.downloadInvoiceListLoading,
  orgUsers: TenantReducers.orgUsers,
  pushInvoiceToBusyLoading: BusyIntegrationReducers.pushInvoiceToBusyLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoice: (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus) => dispatch(InvoiceActions.getInvoice(orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus)),
  syncSO: (payload, callback) => dispatch(UnicommerceIntegrationActions.syncSO(payload, callback)),
  syncInvoice: (payload, callback) => dispatch(ZohoIntegrationActions.syncInvoice(payload, callback)),
  syncTallyInvoice: (payload, callback) => dispatch(TallyIntegrationActions.syncTallyInvoice(payload, callback)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  updateInvoiceStatus: (payload, callback) => dispatch(InvoiceActions.updateInvoiceStatus(payload, callback)),
  downloadInvoice: (payload, callback) => dispatch(InvoiceActions.downloadInvoice(payload, callback)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  downloadInvoiceList: (payload, callback) => dispatch(InvoiceActions.downloadInvoiceList(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  pushInvoiceToBusy: (payload, callback) => dispatch(BusyIntegrationActions.pushInvoiceToBusy(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceList));